import React from 'react';

import { renderUserInputTextarea } from "./DropdownFunctions";

import PropTypes from "prop-types";

const UserInputTextareaControlled = (props ) =>
{
    return (
        <div key={props.keyValue} className={props.containerClassName}>
            { renderUserInputTextarea(props) }
        </div>
    );
}

export default UserInputTextareaControlled;

UserInputTextareaControlled.defaultProps =
{
    defaultClassName: 'form-group'
}

UserInputTextareaControlled.propTypes = {
    onChange: PropTypes.func.isRequired
};